import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

import {
  PARTNER_PORTAL_SECTION_LIST,
  THE_PARTNER_PORTAL,
  KEY_FUNCTIONALITY_FEATURE_SECTIONS,
} from '../../constants/Pages/PartnerWithUs';

import './PartnerPortal.css';

export const PartnerPortal = () => {
  const [expandedSections, setExpandedSections] = useState({});
  return (
    <div className="partner-portal-container">
      <div className="partner-portal-content">
        <h2 className="partner-portal-header">{THE_PARTNER_PORTAL}</h2>
        <h5 className="partner-portal-sub-header">{KEY_FUNCTIONALITY_FEATURE_SECTIONS}</h5>

        <div className="partner-portal-list">
          {PARTNER_PORTAL_SECTION_LIST.map((step) => (
            <Accordion
              sx={{
                '&:first-of-type': {
                  borderTopLeftRadius: '10px',
                  borderTopRightRadius: '10px',
                },
                '&:last-of-type': {
                  borderBottomLeftRadius: '10px',
                  borderBottomRightRadius: '10px',
                },
                '&.Mui-expanded': {
                  margin: '0 auto',
                },
                border: '1px solid black',
                p: '1.25rem',
                p: { xs: '.5rem', sm: '0.5rem' },
                width: { xs: '80%', sm: '50%' },
                margin: '0 auto',
                borderRadius: '10px',
              }}
              expanded={expandedSections[step.title]}
              onChange={() => {
                setExpandedSections((prevState) => {
                  const copyPrevState = { ...prevState };
                  if (prevState[step.title]) {
                    delete copyPrevState[step.title];

                    mixpanel.track('Partner Portal', {
                      stepTitle: step.title,
                      action: 'Close',
                    });

                    return copyPrevState;
                  }

                  mixpanel.track('Partner Portal', {
                    stepTitle: step.title,
                    action: 'Open',
                  });

                  return {
                    ...copyPrevState,
                    [step.title]: step.title,
                  };
                });
              }}
              key={step.title}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                className="partner-portal-section-header"
                sx={{
                  '&.Mui-expanded': {
                    minHeight: '50px',
                  },
                }}
              >
                {step.title}
              </AccordionSummary>

              <AccordionDetails
                sx={{
                  padding: '8px 16px',
                }}
              >
                <div className="partner-portal-section-sub-header">{step.subheader()}</div>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>
    </div>
  );
};
